var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import LazyLoadImage from "./LazyLoadImage";
var SlideImages3 = /** @class */ (function (_super) {
    __extends(SlideImages3, _super);
    function SlideImages3() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.divisionNew = 100;
        _this.opened = false;
        _this.currentImage = 1;
        // Usado no home para ter um delay ao carregar as imagens
        _this.showImages = [];
        return _this;
    }
    SlideImages3.prototype.beforeMount = function () {
        this.divisionNew = Number(this.division);
        for (var i = 1; i <= this.imagesCount; i++) {
            this.showImages[i] = false;
        }
        if (this.division == '33.3333') {
            if (window.innerWidth > 772) {
                this.showImages[0] = true;
                this.showImages[1] = true;
                this.showImages[2] = true;
            }
            else if (window.innerWidth > 574) {
                this.showImages[0] = true;
                this.showImages[1] = true;
            }
            else {
                this.showImages[0] = true;
            }
        }
        this.myEventHandler();
    };
    SlideImages3.prototype.openFullscreen = function (slide) {
        if (slide === void 0) { slide = 0; }
        console.log(slide);
        this.currentImage = slide;
        this.$store.dispatch("toggleFullScreen3", true);
        this.$store.dispatch("setFullScreenOpenPos3", this.currentImage);
    };
    SlideImages3.prototype.previous = function () {
        if (this.currentImage > 1) {
            this.currentImage -= 1;
        }
    };
    SlideImages3.prototype.isShow = function (key) {
        return {
            show: this.showImages[key]
        };
    };
    SlideImages3.prototype.next = function () {
        var _this = this;
        var maxImages = parseInt(this.imagesCount);
        if (!this.disableFixed) {
            if (this.divisionNew == 100) {
                maxImages += 2;
            }
            if (this.divisionNew == 50) {
                maxImages += 1;
            }
        }
        if (this.currentImage < maxImages) {
            this.currentImage += 1;
        }
        if (this.division == '33.3333') {
            if (window.innerWidth > 772) {
                var self = this;
                setTimeout(function () {
                    for (var i = 1; i <= _this.imagesCount + 1; i++) {
                        _this.showImages[i] = true;
                        if (_this.currentImage + 1 == i)
                            break;
                    }
                    _this.currentImage += 1;
                    _this.currentImage -= 1;
                }, 500);
            }
            else if (window.innerWidth > 574) {
                setTimeout(function () {
                    for (var i = 1; i <= _this.imagesCount; i++) {
                        _this.showImages[i] = true;
                        if (_this.currentImage == i)
                            break;
                    }
                    _this.currentImage += 1;
                    _this.currentImage -= 1;
                }, 500);
            }
            else {
                setTimeout(function () {
                    for (var i = 1; i <= _this.imagesCount + 1; i++) {
                        _this.showImages[i] = true;
                        if (_this.currentImage - 1 == i)
                            break;
                    }
                    _this.currentImage += 1;
                    _this.currentImage -= 1;
                }, 500);
            }
        }
    };
    SlideImages3.prototype.created = function () {
        window.addEventListener("resize", this.myEventHandler);
    };
    SlideImages3.prototype.destroyed = function () {
        window.removeEventListener("resize", this.myEventHandler);
    };
    SlideImages3.prototype.myEventHandler = function () {
        if (this.division == '33.3333') {
            if (window.innerWidth > 772) {
                this.divisionNew = 33.3;
            }
            else if (window.innerWidth > 574) {
                this.divisionNew = 50;
            }
            else {
                this.divisionNew = 100;
            }
        }
    };
    SlideImages3.prototype.slideStyle = function () {
        return {
            transform: "translateX(-" + String((this.currentImage - 1) * Number(this.divisionNew)) + "%)"
        };
    };
    SlideImages3.prototype.fullscreenStyle = function () {
        return {
            display: (this.opened && "block") || (!this.opened && "none")
        };
    };
    SlideImages3.prototype.changeFullscreenState = function () {
        if (this.fullscreen) {
            this.opened = !this.opened;
        }
    };
    __decorate([
        Prop()
    ], SlideImages3.prototype, "imagesCount", void 0);
    __decorate([
        Prop()
    ], SlideImages3.prototype, "fullscreen", void 0);
    __decorate([
        Prop({
            default: 100
        })
    ], SlideImages3.prototype, "division", void 0);
    __decorate([
        Prop({
            default: false
        })
    ], SlideImages3.prototype, "disableFixed", void 0);
    SlideImages3 = __decorate([
        Component({
            components: {
                LazyLoadImage: LazyLoadImage
            }
        })
    ], SlideImages3);
    return SlideImages3;
}(Vue));
export default SlideImages3;
